import { ASSET_URL } from '../env/Configurations';

const TRUSTED_VIDEO_DOMAINS = [
  'youtube.com',
  'www.youtube.com',
  'youtu.be',
  'vimeo.com',
  'www.vimeo.com',
  'player.vimeo.com',
];

const TRUSTED_ASSET_PATTERNS = [
  /^https:\/\/hudini-assets-[a-z]+\.s3[.-].*\.amazonaws\.com\//,
  /^https:\/\/assets\.hudini\.io\//,
  /^https:\/\/.*\.cloudfront\.net\//,
];

const _getAssetDomain = () => {
  try {
    if (ASSET_URL) {
      const url = new URL(ASSET_URL);
      return url.hostname;
    }
  } catch (e) {}
  return null;
};

const _isValidUrl = (str) => {
  try {
    const url = new URL(str);
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch (e) {
    return false;
  }
};

const _getDomain = (urlStr) => {
  try {
    return new URL(urlStr).hostname.toLowerCase();
  } catch (e) {
    return null;
  }
};

export const isAllowedVideoUrl = (url) => {
  if (!url || typeof url !== 'string') return true;
  const trimmed = url.trim();
  if (!trimmed) return true;

  if (!_isValidUrl(trimmed)) return false;

  const domain = _getDomain(trimmed);
  if (!domain) return false;

  if (TRUSTED_VIDEO_DOMAINS.some((d) => domain === d || domain.endsWith('.' + d))) {
    return true;
  }

  const assetDomain = _getAssetDomain();
  if (assetDomain && domain === assetDomain) return true;

  if (TRUSTED_ASSET_PATTERNS.some((pattern) => pattern.test(trimmed))) return true;

  return isAllowedExternalUrl(trimmed);
};

export const isAllowedExternalUrl = (url) => {
  if (!url || typeof url !== 'string') return true;
  const trimmed = url.trim();
  if (!trimmed) return true;

  if (!_isValidUrl(trimmed)) return false;

  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return false;
    const hostname = parsed.hostname.toLowerCase();
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0') return false;
    if (/^(10\.|172\.(1[6-9]|2\d|3[01])\.|192\.168\.)/.test(hostname)) return false;
    if (hostname.endsWith('.internal') || hostname.endsWith('.local')) return false;
  } catch (e) {
    return false;
  }

  return true;
};

export const VIDEO_URL_ERROR_MSG = 'Only public video URLs are allowed. Private/internal addresses are blocked.';
export const INVALID_URL_ERROR_MSG = 'Please enter a valid URL.';
